










































import { Component, Vue } from 'vue-property-decorator';

@Component({
  name:"Article",
  components: { 
  },
})
export default class Article extends Vue {
  
 
}
